import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from './../_services';
import { User } from './../_models';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-top-header',
  templateUrl: './top-header.component.html',
  styleUrls: ['./top-header.component.css']
})
export class TopHeaderComponent implements OnInit {

  user: User;
  utm_emailers = '';
  is_vw_creative = true;
  constructor(
      private router: Router,
      private authenticationService: AuthenticationService,
      private ng_router: ActivatedRoute
  ) {
      this.authenticationService.user.subscribe(x => this.user = x);
      this.is_vw_creative = true;
  }

  logout() {
      this.authenticationService.logout();
  }
  getData() {
      alert("aasfaf");
      this.router.navigate(['/my-order']);
  }

  ngOnInit() {
    
     this.utm_emailers = this.getParameterByName('utm_source');
     if(this.utm_emailers == 'vw_emailer' || this.utm_emailers == 'take_a_break' || this.utm_emailers == 'ask_for_a_demo' ){
       this.is_vw_creative = false;
      
    }

  }
  getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


}
